import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import printPersonalMovementDocument from '../../../../utils/printers/CabinCrewMovementHistoryVoucher';

const CabinCrewMovementHistoryPrintButton = ({
  id,
  cabinCrewFullName,
  startDate,
  endDate,
  cabinCrewMovementName,
  cabinCrewId,
  companyBusId,
  documentNumber,
}) => {
  const print = () => {
    const cabinCrewMovementHistory = {
      id,
      cabinCrewFullName,
      startDate,
      endDate,
      cabinCrewMovementName,
      cabinCrewId,
      companyBusId,
      documentNumber,
    };

    printPersonalMovementDocument(cabinCrewMovementHistory);
  };

  return (
    <Button color="secondary" onClick={print} className="ml-2">
      <i className="fa fa-print" /> Imprimir
    </Button>
  );
};

CabinCrewMovementHistoryPrintButton.propTypes = {
  id: PropTypes.number.isRequired,
  cabinCrewFullName: PropTypes.string.isRequired,
  startDate: PropTypes.number.isRequired,
  endDate: PropTypes.number.isRequired,
  cabinCrewMovementName: PropTypes.string.isRequired,
  cabinCrewId: PropTypes.number.isRequired,
  companyBusId: PropTypes.string,
  documentNumber: PropTypes.string,
};

CabinCrewMovementHistoryPrintButton.defaultProps = {
  companyBusId: '-',
  documentNumber: '-',
};

export default CabinCrewMovementHistoryPrintButton;
